<template>
    <div class="home">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h1>Directories for Organizations Serving Diverse Communities</h1>
                    <p>{{pageTitle}}</p>
                </b-col>
            </b-row>


            <b-row class="mt-4">
                <b-col>
                    <a href="/health-services" variant="primary" style="font-size: 25px; text-decoration: underline">Health Services Directory</a>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col>
                    <p>This resource directory of low-cost and immigrant-friendly includes a listing of hospitals,
                        clinics, organizations and services that offer dental services, disability services, domestic
                        violence services and sexual assault services, health services, home health services, hotlines,
                        mental health services, and vision services.</p>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col>
                    <a href="/diverse-media" variant="primary" style="font-size: 25px; text-decoration: underline">Diverse Media Directory</a>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col>
                    <p>A quick reference for individuals working to identify appropriate media channels that reach a
                        broad cross section of diverse groups including communities of color, American Indians, LGBTQ+,
                        people with disabilities, immigrants and refugees in the Twin Cities metro area and Greater
                        Minnesota. Listings are divided by type of media (press, radio, and TV). Each media type is then
                        subdivided into different target audiences. Specific programs and journals are listed
                        alphabetically under each subdivision. </p>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col>
                    <a href="/maa-cbo" variant="primary" style="font-size: 25px; text-decoration: underline">Community Based Organizations Directory</a>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col>
                    <p>A quick reference for individuals working to identify appropriate community-based organizations
                        (CBOs) that serve Minnesota's many diverse communities. Listings are divided by communities
                        served (African, Asian, Multicultural, Eastern European, Latino, etc.). Agencies are then listed
                        alphabetically within each category.</p>
                </b-col>
            </b-row>


        </b-container>
    </div>
</template>

<script>
    import LocalStorageService from '@/common/LocalStorageService';
    import axios from 'axios';
    import axiosRetry from 'axios-retry';

    export default {
        title: "Directories for Organizations Serving Diverse Communities",
        components: {},

        data: () => ({
            pageTitle: 'Welcome to the Refugee and International Health Program and Infectious Disease Equity and Engagement (IDEE) Directories Page.',
        }),

    }
</script>

<style>

</style>